import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TCountryStore,
	TCountryListResponsePayload,
	TCountryDetails,
	TCountryManagementRequest,
	TCountryPagedListResponse,
} from './types';

export const getCountryState = (state: TStoreState): TCountryStore => state.country;

export const getCountryList = createSelector(
	[getCountryState],
	(country: TCountryStore) => country.countryList,
);

// ==========================================:

export const getCountryListData = createSelector(
	[getCountryList],
	(countryList: TCountryListResponsePayload) => countryList,
);

// ==========================================:

export const getCountryListLoading = createSelector(
	[getCountryState],
	(country: TCountryStore) => country.countryListLoading,
);

// ========================================== Country management (reference table)

export const getCountryPagedList = createSelector(
	[getCountryState],
	(country: TCountryStore): TCountryPagedListResponse | null => country.countryPagedList,
);

export const getCountryPagedListLoading = createSelector(
	[getCountryState],
	(country: TCountryStore): boolean => country.countryPagedListLoading,
);

export const getCountryLastListParams = createSelector(
	[getCountryState],
	(country: TCountryStore): TCountryManagementRequest | null => country.countryLastListParams,
);

export const getCountryDetails = createSelector(
	[getCountryState],
	(country: TCountryStore): TCountryDetails | null => country.countryDetails,
);

export const getCountryDetailsLoading = createSelector(
	[getCountryState],
	(country: TCountryStore): boolean => country.countryDetailsLoading,
);

export const getCountrySaveLoading = createSelector(
	[getCountryState],
	(country: TCountryStore): boolean => country.countrySaveLoading,
);

export const getCountrySaveSuccess = createSelector(
	[getCountryState],
	(country: TCountryStore): boolean => country.countrySaveSuccess,
);
